import React from "react";
import {Content, Clear} from './styled';

interface Props {
    tag?: keyof JSX.IntrinsicElements
    className?: string,
    style?: {}
}

const Container: React.FC<Props> = ({
                                        tag = 'div',
                                        children,
                                        className = '',
                                        style
                                    }) => {

    const Tag = tag;

    return (
        <Tag style={style} className={"container " + className}>
            <Content>
                {children}
                <Clear/>
            </Content>
        </Tag>
    );
}

export default Container;